import { ref, reactive, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-690307a1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "over-sea-content"
};
const _hoisted_2 = {
  class: "flex-content"
};
const __default__ = {
  name: 'MetaVrPay'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {}
  },
  emits: ['submitForm'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const rateList = ref([]);
    const metaFormRef = ref(null);
    const metaForm = reactive({
      divide: '',
      pkg: '',
      appId: '',
      appSecret: '',
      accessKey: ''
    });
    const validateForm = () => {
      var _metaFormRef$value;
      (_metaFormRef$value = metaFormRef.value) === null || _metaFormRef$value === void 0 || _metaFormRef$value.validate().then(() => {
        emit('submitForm', metaForm);
      }).catch(e => void 0);
    };
    watch(() => props.detailForm, n => {
      var _n$pkg, _n$appId, _ref, _n$accessKey, _n$rateList, _n$divide;
      if (!n) return;
      metaForm.pkg = (_n$pkg = n.pkg) !== null && _n$pkg !== void 0 ? _n$pkg : '';
      metaForm.id = n.id;
      metaForm.appId = (_n$appId = n.appId) !== null && _n$appId !== void 0 ? _n$appId : '';
      metaForm.appSecret = n.appSecret;
      metaForm.accessKey = (_ref = (_n$accessKey = n.accessKey) !== null && _n$accessKey !== void 0 ? _n$accessKey : n.access_key) !== null && _ref !== void 0 ? _ref : '';
      rateList.value = (_n$rateList = n.rateList) !== null && _n$rateList !== void 0 ? _n$rateList : [];
      metaForm.divide = (_n$divide = n.divide) !== null && _n$divide !== void 0 ? _n$divide : '';
    }, {
      immediate: true,
      deep: true
    });
    expose({
      validateForm
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        model: metaForm,
        ref_key: "metaFormRef",
        ref: metaFormRef,
        rules: __props.rules,
        name: "meta-vr-validate"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "pkg",
          label: "包名："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: metaForm.pkg,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => metaForm.pkg = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appId",
          label: "APPID: "
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: metaForm.appId,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => metaForm.appId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appSecret",
          label: "App secret"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: metaForm.appSecret,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => metaForm.appSecret = $event),
            valueModifiers: {
              trim: true
            },
            placeholder: "请输入 appSecret",
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "divide",
          label: "分成系数："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_select, {
            value: metaForm.divide,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => metaForm.divide = $event),
            options: rateList.value,
            placeholder: "请选择分成比例"
          }, null, 8, ["value", "options"])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});